import { publicInstance } from '@/api/axiosInstance';
import { API_BASE_URL } from '../..';
import {
  CompanyActivationRequest,
  CompanyActivationResponse,
  CompanyActivationTokenValidateResponse,
  CompanyActivationVerifyRequest,
  CompanyActivationVerifyResponse,
} from './Activation.types';

const CONTROLLER_URL = `${API_BASE_URL}/companies`;

export default {
  async validateToken(activationToken?: string) {
    const result =
      await publicInstance.get<CompanyActivationTokenValidateResponse>(
        `${CONTROLLER_URL}/activation-token/${activationToken}/validate`,
      );

    return result.data;
  },

  async verifyLogin(data: CompanyActivationVerifyRequest) {
    const result = await publicInstance.post<CompanyActivationVerifyResponse>(
      `${CONTROLLER_URL}/activation/verify`,
      data,
    );

    return result.data;
  },

  async activate({
    activationToken,
    data,
  }: {
    activationToken: string;
    data: CompanyActivationRequest;
  }) {
    const result = await publicInstance.post<CompanyActivationResponse>(
      `${CONTROLLER_URL}/activation/${activationToken}`,
      data,
    );

    return result.data;
  },
};
